import { FileEntityModel } from "src/store/models/entity/file/entity";
import { FileHelperModel } from "src/store/models/entity/file/helper";

export const encooFileModels = {
  entity: FileEntityModel,
  helper: FileHelperModel,
};
